<template>
  <l-popup :options="popupOptionsInternal"
           @ready="evt => handleReady(evt)"
           class="popup">

    <h5 v-if="title" class="text-center">
      {{ title }}
    </h5>

    <div v-for="(item, index) in rowsFormatted" class="details-row" :key="`row-${index}`">
      <div>{{ item.name }}</div>
      <div>{{ item.value }}</div>
    </div>

    <slot name="extras" v-bind:context="{ itemId }">
      <!-- put additional data here: links, etc -->
    </slot>
  </l-popup>
</template>

<script>
import {
  LPopup,
} from 'vue2-leaflet'

export default {
  name: 'rows-map-popup',
  components: {
    'l-popup': LPopup,
  },

  props: {
    title: {
      // optional
      type: String,
      default: null,
    },

    itemId: {
      // optional, could be used to handle links clicking, etc
      default: 'emptyId',
    },

    popupOptions: {
      type: Object,
      default: () => ({}),
    },

    rows: {
      // mandatory, example:
      // [{name: 'Vessel name', value: 'Triton'}, ... ]
      // or {"Field Name": <field_value>}
      // note: js preserves object insertion order when keys are strings
      default: () => [],
    },
  },

  methods: {
    handleReady(evt) {
      this.$emit('ready', evt, this.itemId);
      // evt._source.on('popupopen', this.handleOpen);
      // evt._source.on('popupclose', this.handleClose);
    },
  },

  computed: {
    popupOptionsInternal() {
      const defaultOptions = {
        itemId: this.itemId,
        permanent: true,
        interactive: true,
        // prevents to move a popup outside of a current map bounds
        // keepInView: true,
      };

      return {
        ...defaultOptions,
        ...this.popupOptions,
      };
    },

    rowsFormatted() {
      // it's possible to have object or array as input prop "rows"
      if(Array.isArray(this.rows)) {
        return this.rows;
      } else if(typeof this.rows === 'object') {
        return Object.keys(this.rows).map(fieldTitle => ({
          name: fieldTitle,
          value: this.rows[fieldTitle],
        }));
      } else {
        return [];
      }
    },
  }
}
</script>

<style scoped lang="scss">
  .popup {
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .details-link {
    font-size: 15px;
  }

  .details-row {
    margin-top: 5px;
    min-width: 200px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px dotted gray;
  }
</style>
